import { render, staticRenderFns } from "./img_map.vue?vue&type=template&id=56579630&scoped=true&"
import script from "./img_map.vue?vue&type=script&lang=js&"
export * from "./img_map.vue?vue&type=script&lang=js&"
import style0 from "./img_map.vue?vue&type=style&index=0&id=56579630&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56579630",
  null
  
)

export default component.exports